import React from "react";
import "./Prompt.css";

const Prompt = ({
  question,
  onYes,
  onNo,
  onCancel,
  yesLabel = "Yes",
  noLabel = "No",
  yesButtonClass = "",
  noButtonClass = "",
}) => {
  // Închide promptul la click pe overlay
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      if (onCancel) {
        onCancel();
      } else {
        onNo();
      }
    }
  };
  return (
    <div className="prompt-overlay" onClick={handleOverlayClick}>
      <div className="prompt-box">
        <button className="prompt-close" onClick={onCancel || onNo}>
          ×
        </button>
        <div className="prompt-question">{question}</div>
        <div className="prompt-actions">
          <button
            className={`button-middle${
              yesButtonClass ? " " + yesButtonClass : ""
            }`}
            onClick={onYes}
          >
            {yesLabel}
          </button>
          <button
            className={`button-middle${
              noButtonClass ? " " + noButtonClass : ""
            }`}
            onClick={onNo}
            autoFocus
          >
            {noLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Prompt;
